export function computeMaxGridColumns(count: number) {
  if (count < 5) return count
  if (count % 4 === 0) return 4

  return 3
}
